import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './locales/i18n';
import App from './App';
import apolloClient from '../src/utils/apollo-client-setup';
import { ApolloProvider } from '@apollo/client';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <ApolloProvider client={apolloClient}>
          <App />
        </ApolloProvider>
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
